import { Grid, Typography, Button, MenuItem, TextField, FormControl, FormControlLabel } from "@mui/material";
import { useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { SelectOption } from "ui";
import { SelectedPerson_PersonFragment, getFragmentData, PEOPLE_PAGE_QUERY } from "ft-shared-graphql";
import { SELECTED_PERSON_FRAGMENT } from "ft-shared-graphql";
export type SelectLaunchPersonProps = {
    onSelect: (person: string) => void;
}
// const mapPeopleToSelect = (data: any) => data.map((x: any) => ({
//     label: `${data.node!.firstName} ${data.node!.lastName} `,
//     value: data.node.id
// }
// ))
function mapPeopleToSelect(data: any) {
    return {
        label: `${data.node!.firstName} ${data.node!.lastName} `,
        value: data.node.id,
    }
}

export default function SelectLaunchPerson({ onSelect }: SelectLaunchPersonProps) {
    const { loading, data } = useQuery(PEOPLE_PAGE_QUERY, {
        variables: { role: "LAUNCH_SELF_ACCESS", first: 100 }
    })
    const [launchPeople, setLaunchPeople] = useState<SelectOption[] | null>(null)
    const [selectedPersonId, setSelectedPersonId] = useState();
    useEffect(() => {
        if (!loading && data?.people?.edges) {
            const _data = data?.people?.edges
                .filter((edge: any) => !edge.node.expired).map(mapPeopleToSelect)
            setLaunchPeople(_data as SelectOption[])
        }
    }, [loading, data])
    const handleSelect = (event: any) => {
        setSelectedPersonId(event.target.value)
        onSelect(event.target.value)
    }
    if (!launchPeople) {
        return <div>Loading...</div>
    }
    return (
        <>
            <TextField
                onChange={handleSelect}
                value={selectedPersonId}
                label={'Select a person to launch on behalf of'}
                fullWidth select>
                {/* <MenuItem value="" disabled>
                                <em>Please select a person</em>
                            </MenuItem> */}
                {launchPeople?.map((option: SelectOption) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>


            {/* <TextField
                    onChange={handleSelect}
                    value={selectedPersonId}
                    fullWidth select>
                    <MenuItem value="" disabled>
                        <em>Please select a person</em>
                    </MenuItem>
                    {launchPeople?.map((option: SelectOption) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField> */}

            {/* <Field name="launchPerson" render={(fieldProps) => (
               
            )} /> */}

            {/* <SelectField
                options={launchPeople}
            // label="Sele"
            /> */}
            {/* {launchPeople.length > 0 && (launchPeople.map((person: PersonDataType) => (<Grid size={12} alignItems="center">
                <Button sx={{
                    backgroundColor: "primary.main", "&:hover": { backgroundColor: "primary.light" }, width: 180,
                    marginTop: "16px",
                    padding: 1
                }}
                    type="submit"
                    variant="contained"
                    onClick={() => onSelect(person)}>{person!.firstName} {person!.lastName}</Button>
            </Grid>)))} */}
        </>
    )
}